const setupCheckoutPaymentRefresh = () => {
    if (!document.body.classList.contains('woocommerce-checkout')) {
        return;
    }

    if (!window.jQuery) {
        return;
    }

    const $ = window.jQuery;
    const $body = $(document.body);
    let refreshTimer = null;

    const triggerCheckoutUpdate = () => {
        if (refreshTimer) {
            window.clearTimeout(refreshTimer);
        }

        refreshTimer = window.setTimeout(() => {
            $body.trigger('update_checkout');
        }, 60);
    };

    $body.on('change', 'input[name="payment_method"]', triggerCheckoutUpdate);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCheckoutPaymentRefresh, {
        once: true,
    });
} else {
    setupCheckoutPaymentRefresh();
}
